import './Cover.css'

function Cover(){
    return(
        <div className='cover'>

        </div>
    )
}

export default Cover;